var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_7783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5205 12.2729C23.5205 11.422 23.4441 10.6038 23.3023 9.81836H12.0005V14.4602H18.4587C18.1805 15.9602 17.335 17.2311 16.0641 18.082V21.0929H19.9423C22.2114 19.0038 23.5205 15.9275 23.5205 12.2729Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.9993C15.24 23.9993 17.9564 22.9248 19.9419 21.092L16.0637 18.0811C14.9891 18.8011 13.6146 19.2266 12 19.2266C8.87457 19.2266 6.22911 17.1157 5.28547 14.2793H1.27637V17.3884C3.25092 21.3102 7.30911 23.9993 12 23.9993Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28547 14.2804C5.04547 13.5604 4.9091 12.7913 4.9091 12.0004C4.9091 11.2095 5.04547 10.4404 5.28547 9.72043V6.61133H1.27637C0.463637 8.23133 0 10.0641 0 12.0004C0 13.9368 0.463637 15.7695 1.27637 17.3895L5.28547 14.2804Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.77274C13.7618 4.77274 15.3437 5.37819 16.5873 6.56729L20.0291 3.12546C17.9509 1.18909 15.2346 0 12 0C7.30911 0 3.25092 2.6891 1.27637 6.61092L5.28547 9.72002C6.22911 6.88365 8.87457 4.77274 12 4.77274Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_7783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.4e1364b8b80d679af8e0c4b6960b8bfb.svg";
export { ForwardRef as ReactComponent };